import { Component, ElementRef, AfterViewInit } from '@angular/core';
import { VrRadioButton } from '../models/vr-radio-button';

@Component({
  selector: 'vrc-radio-button',
  templateUrl: './vrc-radio-button.component.html',
  styleUrls: ['./vrc-radio-button.component.scss']
})
export class VrcRadioButtonComponent extends VrRadioButton implements AfterViewInit {
  constructor(private element: ElementRef) {
    super();
  }

  ngAfterViewInit(): void {
    this.content = this.element.nativeElement?.innerHTML;
  }
}
